import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { find } from 'lodash';
import ReactMarkdown from 'react-markdown';

import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardActionArea from '@material-ui/core/CardActionArea';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import * as MerchantService from '../../api/merchantService';
import * as StampCampaignService from '../../api/stampCampaignService';
import * as StampCardService from '../../api/stampCardService';
import useStampCardContext from '../../hooks/useStampCardContext';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 450,
    padding: 20,
  },
  cardContainer: {
    cursor: 'pointer',
    borderBottomRightRadius: 15,
    borderBottomLeftRadius: 15,
    padding: theme.spacing(2),
    boxShadow: '0 2px 10px rgba(199, 199, 199, 1)',
    backgroundColor: '#FFFFFB',
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'left',
  },
  avatar: {
    height: 80,
    width: 80,
    boxShadow: '0 2px 10px rgba(199, 199, 199, 1)',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(4),
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: theme.spacing(),
    marginTop: theme.spacing(),
  },
  cardInfoContainer: {
    padding: theme.spacing(),
  },
  cardTitle: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: 18,
    textAlign: 'left',
    marginTop: theme.spacing(),
    marginLeft: theme.spacing(2),
  },
  subtitle: {
    marginTop: theme.spacing(),
    textAlign: 'left',
    marginLeft: theme.spacing(2),
  },
  cardMedia: {
    height: 220,
    maxWidth: 450,
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    backgroundSize: 'cover',
  },
  markdown: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(),
    fontFamily: 'ClarikaGeometric',
    fontSize: 14,
    fontWeight: 400,
    marginLeft: theme.spacing(2),
  },
}));

type Props = {
  merchantId: string;
  cardList: StampCardService.MemberStampCard[] | [];
};

export default function LoyaltyCard({ merchantId, cardList }: Props) {
  const selectedStampCard = useStampCardContext();
  const classes = useStyles();
  const [merchant, setMerchant] = useState<MerchantService.Merchant | null>(
    null
  );
  const [stampCampaignList, setStampCampaignList] = useState<
    StampCampaignService.StampCampaign[]
  >([]);

  useEffect(() => {
    const fetchMerchant = async () => {
      const res = await MerchantService.get(merchantId);

      setMerchant(res);
    };

    fetchMerchant();
  }, [merchantId]);

  useEffect(() => {
    const fetchStampCampaignList = () => {
      let stampList: StampCampaignService.StampCampaign[] = [];
      cardList.forEach(async (card) => {
        const res = await StampCampaignService.get(card.loyalty_campaign.ID);

        if (res) {
          console.log(res);
          stampList = stampList.concat([res]);
          console.log(stampList);
          setStampCampaignList(stampList);
        }
      });
    };
    if (cardList.length > 0) {
      fetchStampCampaignList();
    }
  }, [cardList]);

  if (!merchant) {
    return null;
  }

  return (
    <Grid item xs={12} className={classes.root}>
      {merchant.cover && (
        <CardMedia
          className={classes.cardMedia}
          image={merchant.cover.versions.xl}
          onClick={() => {
            if (selectedStampCard) {
              if (cardList.length > 0) {
                selectedStampCard.setStampCard({
                  selectedStampCardId: cardList[0].id,
                  selectedSlotNumber: cardList[0].slotNumber,
                  selectedStampCampaignId: cardList[0].loyalty_campaign.ID,
                });
              } else {
                selectedStampCard.setStampCard({
                  selectedStampCardId: '',
                  selectedSlotNumber: 0,
                  selectedStampCampaignId: '0',
                });
              }
            }
          }}
          to={`/merchant/${merchant.id}`}
          component={Link}
        />
      )}
      <Card className={classes.cardContainer}>
        <CardActionArea
          onClick={() => {
            if (selectedStampCard) {
              if (cardList.length > 0) {
                selectedStampCard.setStampCard({
                  selectedStampCardId: cardList[0].id,
                  selectedSlotNumber: cardList[0].slotNumber,
                  selectedStampCampaignId: cardList[0].loyalty_campaign.ID,
                });
              } else {
                selectedStampCard.setStampCard({
                  selectedStampCardId: '',
                  selectedSlotNumber: 0,
                  selectedStampCampaignId: '0',
                });
              }
            }
          }}
          to={`/merchant/${merchant.id}`}
          component={Link}
        >
          <div className={classes.contentContainer}>
            <Avatar
              alt={merchant.name}
              src={merchant.logo?.versions.xl}
              className={classes.avatar}
            />
            <Typography variant="h5" className={classes.title} gutterBottom>
              {merchant.name}
            </Typography>
          </div>
        </CardActionArea>
        {cardList &&
          cardList.length > 0 &&
          cardList.map((card, idx) => {
            let selectedStampCampaign = find(
              stampCampaignList,
              function (stampCampaign) {
                return stampCampaign.id === card.loyalty_campaign.ID;
              }
            );
            return (
              <CardActionArea
                onClick={() => {
                  if (selectedStampCard) {
                    selectedStampCard.setStampCard({
                      selectedStampCardId: card.id,
                      selectedSlotNumber: card.slotNumber,
                      selectedStampCampaignId: card.loyalty_campaign.ID,
                    });
                  }
                }}
                to={`/merchant/${merchant.id}`}
                component={Link}
              >
                <div className={classes.cardInfoContainer}>
                  <Typography className={classes.cardTitle} gutterBottom>
                    {card.stampCampaignName}
                  </Typography>
                  {selectedStampCampaign && (
                    // <Typography
                    //   variant="body2"
                    //   className={classes.subtitle}
                    //   gutterBottom
                    // >
                    //   {selectedStampCampaign.description}
                    // </Typography>
                    <ReactMarkdown className={classes.markdown}>
                      {selectedStampCampaign.description}
                    </ReactMarkdown>
                  )}
                </div>
              </CardActionArea>
            );
          })}
      </Card>
    </Grid>
  );
}
